import { ConciergeGeneralSettingsParser } from "@redotech/redo-concierge-settings-common/general";
import * as z from "zod";
import { object } from "zod";
export const updateConciergeGeneralSettings = {
  name: "updateConciergeGeneralSettings" as const,
  input: object({ settings: ConciergeGeneralSettingsParser.partial() }),
  output: z.null(),
};
